import PropTypes from 'prop-types'
import { TagListRoot, Tag } from './tag-list.styles'

const TagList = (props) => {
  const { tags } = props

  return tags && tags.length >= 1 ? (
    <TagListRoot>
      {tags && tags.map(tag => <Tag key={tag.label}>#{tag.label}</Tag>)}
    </TagListRoot>
  ) : null
}

TagList.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
  })),
}

TagList.defaultProps = {}

export default TagList
